export const tipoAssociacaoOptions = [
    {
        value: 'PROCESSO',
        label: 'Processo'
    },
    {
        value: 'PROCESSO_ITEM',
        label: 'Item do Processo'
    },
];